import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Clock, PawPrint, LogOut } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-slate-50 p-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#166534]">
        <PawPrint className="h-7 w-7 text-white" />
      </div>
      <div className="flex items-center gap-2 rounded-full bg-amber-100 px-4 py-1.5 text-sm font-semibold text-amber-800">
        <Clock className="h-4 w-4" /> In attesa di approvazione
      </div>
      <h1 className="max-w-md font-heading text-2xl font-extrabold text-slate-900">
        Il tuo accesso è in attesa di approvazione
      </h1>
      <p className="max-w-md text-sm text-slate-500">
        Ciao {user?.name || user?.email}, il tuo account è stato creato correttamente. Un coordinatore
        deve approvare il primo accesso prima che tu possa utilizzare la piattaforma. Riprova più tardi.
      </p>
      <Button variant="outline" data-testid="pending-logout-button"
        onClick={async () => { await logout(); navigate("/login"); }}>
        <LogOut className="mr-2 h-4 w-4" /> Esci
      </Button>
    </div>
  );
}
